module.exports = "../fonts/slick.svg";